import React from 'react'
import { Card } from '../ui'

const RecipeCardSkeleton = () => (
  <div className="animate-pulse" style={{ animationDuration: '0.8s' }}>
    <Card className="flex flex-col h-full transition-opacity duration-150 opacity-80">
      <div className="w-full aspect-[16/9] bg-gray-200 rounded-t-lg"></div>
      <div className="px-3 py-2">
        <div className="h-5 bg-gray-200 rounded w-3/4"></div>
      </div>
      <div className="mt-auto px-3 pb-2 flex items-center justify-between">
        <div className="h-4 bg-gray-200 rounded w-16"></div>
        <div className="h-3 bg-gray-200 rounded-full w-24"></div>
      </div>
      <div className="mt-auto px-3 py-2 border-t border-gray-100 bg-gray-50/50 rounded-b-lg flex justify-between">
        <div className="flex gap-2">
          <div className="h-6 w-12 bg-gray-200 rounded"></div>
          <div className="h-6 w-12 bg-gray-200 rounded"></div>
        </div>
        <div className="h-6 w-12 bg-gray-200 rounded"></div>
      </div>
    </Card>
  </div>
)

export default RecipeCardSkeleton
